export const LANGUAGE_CHANGE = "LANGUAGE_CHANGE";
export const LANGUAGE_REQUEST = "LANGUAGE_REQUEST";
export const LANGUAGE_SET = "LANGUAGE_SET";
export const USER_SET = "USER_SET";
export const FIRST_TIME = "FIRST_TIME";
export const SET_CART_COUNT = "SET_CART_COUNT";
